import { Network } from "./network";

export class NetworkProductConfigurationCluster {
  private key: string;
  private companyFiscalNumber: string;
  private allNetworks: boolean;
  private networkSelectedList: Network[];
  private networkSelectedListPrev: Array<Network>;
  private networkDetails: Array<Network>;
  private priceIntegration: boolean;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(fiscalNumber: string): void {
    this.companyFiscalNumber = fiscalNumber;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setAllNetworks(value: boolean): void {
    this.allNetworks = value;
  }

  getAllNetworks(): boolean {
    return this.allNetworks;
  }

  setNetworkSelectedList(configuration: Network[]): void {
    this.networkSelectedList = configuration;
  }

  getNetworkSelectedList(): Network[] {
    return this.networkSelectedList;
  }

  setNetworkSelectedListPrev(configuration: Array<Network>): void {
    this.networkSelectedListPrev = configuration;
  }

  getNetworkSelectedListPrev(): Array<Network> {
    return this.networkSelectedListPrev;
  }

  getNetworkDetails(): Array<Network> {
    return this.networkDetails;
  }

  setNetworkDetails(networkDetails: Array<Network>): void {
    this.networkDetails = networkDetails;
  }

  getPriceIntegration(): boolean {
    return this.priceIntegration;
  }

  setPriceIntegration(value: boolean): void {
    this.priceIntegration = value;
  }

  isNew(): boolean {
    return !this.key;
  }
}
